/**
 * Questo file contiene il tipo 'formStep'
 * riporta l'enim dei vari step del forum per renderlo piu leggibile
 */

export enum PagesEnum {
	ReservationForm = 0,
	PersonalArea = 1,
	ChangePassword = 2,
	Login = 3,
	Payment = 4,
	PrivacyPolicy = 5,
	Notification = 6,
	Help = 7,
}
